import { C_TEAL, C_CORAL, C_SAND, rgba } from '../utils/palette';
import { setupCanvas } from '../utils/canvas';
import { YEARS } from '../utils/constants';

export const CHART_KEY = [
    'X = points year before last · Y = points last season',
    'Above diagonal = improved · below = declined · dot size = total points',
    'Tap a dot for rider name',
];

const y1 = YEARS[2];
const y2 = YEARS[1];

/**
 * @param {HTMLCanvasElement} canvas
 * @param {HTMLElement} tooltip
 * @param {Array} riders
 * @param {number} clipPct  zoom clip percentage (100 = full range)
 */
export function renderTrajectory(canvas, tooltip, riders, clipPct = 100) {
    if (!canvas || !riders.length) return;

    const data = riders
        .filter(r => r.pointsByYear?.[y1] || r.pointsByYear?.[y2])
        .map(r => ({ x: r.pointsByYear?.[y2] || 0, y: r.pointsByYear?.[y1] || 0, pos: r.position, name: r.rider }));
    if (!data.length) return;

    const w = canvas.parentElement.clientWidth || 280;
    const h = 160;
    const ctx = setupCanvas(canvas, w, h);
    ctx.clearRect(0, 0, w, h);

    const autoMaxV = Math.max(...data.map(d => Math.max(d.x, d.y)), 1) * 1.05;
    const maxV = autoMaxV * (clipPct / 100);
    const pad  = { top: 10, right: 10, bottom: 24, left: 28 };
    const cw   = w - pad.left - pad.right;
    const ch   = h - pad.top - pad.bottom;

    const px = v => pad.left + (v / maxV) * cw;
    const py = v => pad.top + ch - (v / maxV) * ch;

    ctx.strokeStyle = rgba('#888', 0.18);
    ctx.lineWidth = 0.5;
    ctx.beginPath();
    ctx.moveTo(pad.left, pad.top);
    ctx.lineTo(pad.left, pad.top + ch);
    ctx.moveTo(pad.left, pad.top + ch);
    ctx.lineTo(pad.left + cw, pad.top + ch);
    ctx.stroke();

    ctx.strokeStyle = rgba('#888', 0.2);
    ctx.lineWidth = 1;
    ctx.setLineDash([3, 3]);
    ctx.beginPath();
    ctx.moveTo(px(0), py(0));
    ctx.lineTo(px(maxV * 0.95), py(maxV * 0.95));
    ctx.stroke();
    ctx.setLineDash([]);

    const dots = [];
    data.forEach(d => {
        const improving = d.y > d.x * 1.05;
        const declining  = d.x > d.y * 1.05;
        const cx = px(d.x), cy = py(d.y);
        ctx.beginPath();
        ctx.arc(cx, cy, 3, 0, Math.PI * 2);
        ctx.fillStyle = improving ? rgba(C_TEAL, 0.75) : declining ? rgba(C_CORAL, 0.7) : rgba(C_SAND, 0.8);
        ctx.fill();
        dots.push({ cx, cy, name: d.name, pos: d.pos });
    });

    ctx.fillStyle = '#bbb';
    ctx.font = '8px monospace';
    ctx.textAlign = 'center';
    ctx.fillText(y2, pad.left + cw / 2, h - 4);
    ctx.save();
    ctx.translate(9, pad.top + ch / 2);
    ctx.rotate(-Math.PI / 2);
    ctx.fillText(y1, 0, 0);
    ctx.restore();

    const lx = w - pad.right - 52;
    const ly = pad.top + 2;
    [[C_TEAL, 'rising'], [C_CORAL, 'falling'], [C_SAND, 'stable']].forEach(([c, label], i) => {
        ctx.fillStyle = rgba(c, 0.75);
        ctx.fillRect(lx, ly + i * 12, 7, 7);
        ctx.fillStyle = '#aaa';
        ctx.font = '8px sans-serif';
        ctx.textAlign = 'left';
        ctx.fillText(label, lx + 10, ly + i * 12 + 7);
    });

    if (canvas._trajMM) canvas.removeEventListener('mousemove',  canvas._trajMM);
    if (canvas._trajML) canvas.removeEventListener('mouseleave', canvas._trajML);
    canvas._trajMM = (e) => {
        const rect = canvas.getBoundingClientRect();
        const mx   = e.clientX - rect.left;
        const my   = e.clientY - rect.top;
        const hit  = dots.find(d => Math.hypot(d.cx - mx, d.cy - my) <= 6);
        if (hit && tooltip) {
            tooltip.textContent   = `${hit.pos}  ${hit.name}`;
            tooltip.style.display = 'block';
            const _tw1 = tooltip.offsetWidth;
            tooltip.style.left    = (mx + 10 + _tw1 > canvas.parentElement.clientWidth ? mx - _tw1 - 10 : mx + 10) + 'px';
            tooltip.style.top     = (my - 24) + 'px';
        } else if (tooltip) {
            tooltip.style.display = 'none';
        }
    };
    canvas._trajML = () => { if (tooltip) tooltip.style.display = 'none'; };
    canvas.addEventListener('mousemove',  canvas._trajMM);
    canvas.addEventListener('mouseleave', canvas._trajML);
}
